import { createAsyncThunk } from "@reduxjs/toolkit";
import { setLoading, setLoadingForPopUp } from "../../Slice/loading/loadingSlice";
import authApi from "../../authApi";
import {
  setDataForJobTable,
  setdiscussionJobDetails,
  setDiscussionScoop,
  setdiscussionScoopDetails,
  setFileFolders,
  setFileTotal,
  setFullScoopDetailList,
  setGeneralMasterDropDownList,
  setGlobalSearch,
  setHoliDayListing,
  setitemsScoopsDropdown,
  setJobChainData,
  setJobData,
  setJobDetailChange,
  setMasterDropDownList,
  setOrderId,
  setOverdueJobs,
  setAbsentLinguistList,
  setPriceListDetails,
  setPriceListForResources,
  setProjectDetail,
  setProjectScoopOrders,
  setProjectScoopOrdersBadge,
  setScoopClientDropdown,
  setScoopDetailsForDashboardOverview,
  setScoopTable,
  setselectJobDataByOrderId,
  setTmsSummaryJobs,
  setTmsSummaryJobsBadge,
  setUpcomingDeliveries,
  setUserDashboardTabs,
  setProjectScoopGrouped,
  setFileTotalForJobs,
  setJobDetails,
  setEditingUsers,
  setAlertNotification,
  markAlertSeenInState,
  markAllAlertsSeenInState,
  setScoopTemplates,
  setScoopTemplateDetail,
  setLatestRequestId,
} from "../../Slice/DashboardModule/DashboardSlice";
import { showSnackbar } from "../../Slice/snackbar/snackbarSlice";
import { setScoopDetail } from "../../Slice/ClientModule/ClientSlice";

export const projectScoopList = createAsyncThunk(
  "dashboardProjectsOrderScoopGet/list",
  async (
    { id, page, perPage, tabName, search, isGlobal, sortBy, sortOrder, completedTabGrouped },
    { dispatch, getState, requestId }
  ) => {
    dispatch(setLatestRequestId(requestId));
    dispatch(setLoading(true));

    try {
      const url = `/dashboardProjectsOrderScoopGet`;

      const requestBody = {
        id: id,
        page: page + 1,
        perPage,
        tabName,
        completedTabGrouped,
        ...(search && { search }),
        ...(isGlobal ? { customTab: 0 } : { customTab: 1 }),
        ...(Array.isArray(sortBy) && sortBy.length > 0 && { sortBy }),
      };

      const response = await authApi.post(url, requestBody);

      const state = getState();
      const latestRequestId = state.root?.DashboardModule?.latestRequestId;

      if (latestRequestId !== requestId) {
        return; // Ignore response from stale request
      }

      if (response?.status === 200) {
        if (completedTabGrouped && response?.data?.groupedData) {
          dispatch(setProjectScoopGrouped(response.data.groupedData));
        }
        dispatch(setProjectScoopOrders(response?.data));
        return response?.data;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      const state = getState();
      const latestRequestId = state.root?.DashboardModule?.latestRequestId;
      if (latestRequestId === requestId) {
        dispatch(setLoading(false));
      }
    }
  }
);

export const getTmsSummeryJobs = createAsyncThunk(
  "getJobsFromTmsSummeryViewDashboard/list",
  async ({ page, perPage, tabName, search, sortBy, sortOrder }, { dispatch }) => {
    dispatch(setLoading(true));

    try {
      let url = `/getJobsFromTmsSummeryViewDashboard?page=${
        page + 1
      }&perPage=${perPage}&tabName=${tabName}`;
      if (search) {
        url += `&search=${search}`;
      }
      if (sortBy && sortOrder) {
        url += `&sortBy=${sortBy}&sortOrder=${sortOrder}`;
      }

      const response = await authApi.get(url);

      if (response?.status === 200) {
        dispatch(setTmsSummaryJobs(response?.data));
        return response?.data; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const scoopStatusDropdown = createAsyncThunk(
  "scoopStatusChange",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));

    try {
      const response = await authApi.post(`/scoopStatusChange`, request);

      if (response?.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
        return response?.data; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const getHolidayList = createAsyncThunk(
  "scoopStatusChange",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));

    try {
      const response = await authApi.get(`/holidayGet`);

      if (response?.status === 200) {
        dispatch(setHoliDayListing(response?.data[0]));
        return response?.data; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const getmasterDropdownList = createAsyncThunk(
  "getmasterdropdownlist",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));

    try {
      const response = await authApi.get(`/masterDropdownList?client=${request?.client ? request?.client : ""
        }&jobStatus=${true}&resource=${true}&masterDropdownList=${true}&userManager=${2}&userCoordinator=${3}&userQaSpecialist=${4}&orderId=${request.order_id
        }&JobTemplates=true&clientPriceList=true&joboption=true&jobChainData=true&scoopStatus=true&projectType=true&masterPriceListWithChild=true&clientContact=true&languages=true
 `);

      if (response?.status === 200) {
        dispatch(setMasterDropDownList(response.data?.data));
        return response?.data; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const scoopProjectBadgeForTabs = createAsyncThunk(
  "dashboardProjectsOrderCount",
  async (request, { dispatch }) => {
    const userId =
      request && typeof request === "object" ? request.userId ?? request.id : request;
    const silent = Boolean(request && typeof request === "object" && request.silent);

    if (!silent) dispatch(setLoading(true));

    try {
      const response = await authApi.get(`/dashboardProjectsOrderCount/${userId}`);

      if (response?.status === 200) {
        dispatch(setProjectScoopOrdersBadge(response?.data));
        return response?.data; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error; // Ensures error handling in components
    } finally {
      if (!silent) dispatch(setLoading(false));
    }
  }
);
export const tmsSummaryBadgeForTabs = createAsyncThunk(
  "getJobsFromTmsSummeryViewCount",
  async (request, { dispatch }) => {
    const silent = Boolean(request && typeof request === "object" && request.silent);
    if (!silent) dispatch(setLoading(true));

    try {
      const response = await authApi.get(`/getJobsFromTmsSummeryViewCount`);

      if (response?.status === 200) {
        dispatch(setTmsSummaryJobsBadge(response?.data));
        return response?.data; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error; // Ensures error handling in components
    } finally {
      if (!silent) dispatch(setLoading(false));
    }
  }
);
// ---------------------- Overview Accordion -------------------------
export const upcomingDeliveriesList = createAsyncThunk(
  "getUpcomingDeliveries",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));

    try {
      const response = await authApi.get(`/getUpcomingDeliveries`);
      if (response?.status === 200) {
        dispatch(setUpcomingDeliveries(response?.data));
        return response?.data; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const overDuejobsList = createAsyncThunk("getOverDueJobs", async (request, { dispatch }) => {
  dispatch(setLoading(true));

  try {
    const response = await authApi.get(`/getOverDueJobs`);

    if (response?.status === 200) {
      dispatch(setOverdueJobs(response?.data));
      return response?.data; // Return data for component use
    }
  } catch (error) {
    console.error("API Error:", error);
    throw error; // Ensures error handling in components
  } finally {
    dispatch(setLoading(false));
  }
});
export const absentLinguistList = createAsyncThunk(
  "absentLinguistList",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));

    try {
      const response = await authApi.get(`/absentLinguistList/2`);

      if (response?.status === 200) {
        dispatch(setAbsentLinguistList(response?.data?.data || []));
        return response?.data;
      }
      dispatch(setAbsentLinguistList([]));
    } catch (error) {
      console.error("API Error:", error);
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const jobDetailsChangeList = createAsyncThunk(
  "jobDetailchange",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));

    try {
      const response = await authApi.get(`/jobDetailchange/${request}`);

      if (response?.status === 200) {
        dispatch(setJobDetailChange(response?.data));
        dispatch(setLoading(false));
        return response?.data; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const recentActivityGet = createAsyncThunk(
  "recentActivityGet",
  async ({ id = 1, page = 1, limit = 50 }, { dispatch }) => {
    try {
      const response = await authApi.get(`/recentActivityGet/${id}?page=${page}&limit=${limit}`);
      if (response?.status === 200) {
        return response?.data; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error; // Ensures error handling in components
    }
  }
);
export const updateJobSummeryDetailsChange = createAsyncThunk(
  "jobSummeryJobDetailsUpdate",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));

    try {
      const response = await authApi.put(
        `/jobSummeryJobDetailsUpdate/${request?.job_summmeryId}`,
        request
      );

      if (response?.status === 200) {
        // dispatch(jobDetailsChangeList(request?.job_summmeryId));
        dispatch(setLoading(false));
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
        return response?.data; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const getJobSourceTragetFilesTotal = createAsyncThunk(
  "getJobSourceTragetFilesTotal",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.get(`/getJobSourceTragetFilesTotal/${request}`);
      if (response?.status === 200) {
        dispatch(setLoading(false));
        return response?.data; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const generateNewOrderId = createAsyncThunk("order/", async (request, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await authApi.post(`/order`, request);

    if (response?.status === 200) {
      dispatch(setOrderId(response?.data));
      dispatch(setLoading(false));
      return response; // Return data for component use
    }
  } catch (error) {
    console.error("API Error:", error);
    dispatch(setLoading(false));
    throw error; // Ensures error handling in components
  } finally {
    dispatch(setLoading(false));
  }
});
export const updateJobTemplate = createAsyncThunk(
  "order/",
  async ({ id, ...request }, { dispatch }) => {
    try {
      const response = await authApi.put(`/updateJobTemplate/${id}`, request);
      if (response?.status === 200) {
        return response; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error; // Ensures error handling in components
    }
  }
);
export const saveJobTemplate = createAsyncThunk(
  "saveJobTemplate/",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.post(`/saveJobTemplate`, request);
      if (response.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
        return response; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      throw error; // Ensures error handling in components
    } finally {
    }
  }
);
export const getScoopTemplateList = createAsyncThunk(
  "getScoopTemplateList/",
  async (_, { dispatch }) => {
    try {
      const response = await authApi.get(`/getScoopTemplateList`);
      if (response?.status === 200) {
        dispatch(setScoopTemplates(response?.data?.data || []));
        return response?.data;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  }
);

export const updateScoopTemplate = createAsyncThunk(
  "updateScoopTemplate/",
  async ({ id, template_name, scoop_snapshot, project_snapshot }, { dispatch }) => {
    try {
      const body = { template_name };
      if (scoop_snapshot != null) {
        body.scoop_snapshot = scoop_snapshot;
      }
      if (project_snapshot != null) {
        body.project_snapshot = project_snapshot;
      }
      const response = await authApi.put(`/updateScoopTemplate/${id}`, body);
      if (response?.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
        dispatch(getScoopTemplateList());
        return response?.data;
      }
      throw new Error(response?.data?.msg || "Failed to update scoop template.");
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg || "Failed to update scoop template.",
          type: "error",
        })
      );
      throw error;
    }
  }
);

export const deleteScoopTemplate = createAsyncThunk(
  "deleteScoopTemplate/",
  async (id, { dispatch }) => {
    try {
      const response = await authApi.delete(`/scoopTemplatesDelete/${id}`);
      if (response?.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
        dispatch(getScoopTemplateList());
        return response?.data;
      }
      throw new Error(response?.data?.msg || "Failed to delete scoop template.");
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg || "Failed to delete scoop template.",
          type: "error",
        })
      );
      throw error;
    }
  }
);

export const getScoopTemplateOne = createAsyncThunk(
  "getScoopTemplateOne/",
  async (id, { dispatch }) => {
    try {
      const response = await authApi.get(`/getScoopTemplateOne/${id}`);
      if (response?.status === 200) {
        dispatch(setScoopTemplateDetail(response?.data?.data || null));
        return response?.data;
      }
      throw new Error(response?.data?.msg || "Failed to fetch scoop template.");
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  }
);
export const saveScoopTemplate = createAsyncThunk(
  "saveScoopTemplate/",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.post(`/saveScoopTemplate`, request);
      if (response?.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
        return response?.data;
      }
    } catch (error) {
      console.error("API Error:", error);
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg || "Failed to save scoop template.",
          type: "error",
        })
      );
      throw error;
    }
  }
);
export const checkResourceAvailability = createAsyncThunk(
  "checkresourcavailability/",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.post(`/checkUserAbsent/${request.resource}`, request.payload);
      return response;
    } catch (error) {
      console.error("API Error:", error);
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const generateOrderNumber = createAsyncThunk(
  "orderNumberget/",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.get(`/orderNumberget/${request}`);

      if (response?.status === 200) {
        return response; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const generalCreate = createAsyncThunk("general/", async (request, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await authApi.post(`/general`, request);

    if (response?.status === 200) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: response?.data?.msg,
          type: "success",
        })
      );
      return response?.data; // Return data
    }
  } catch (error) {
    dispatch(
      showSnackbar({
        message: error?.response?.data?.msg,
        type: "error",
      })
    );
    console.error("API Error:", error);
    dispatch(setLoading(false));
    throw error; // Ensures error handling in components
  } finally {
    dispatch(setLoading(false));
  }
});
export const saveProject = createAsyncThunk("saveProject/", async (request, { dispatch }) => {
  try {
    const response = await authApi.post(`/saveProject`, request);

    if (response?.data?.status === 422) {
      dispatch(
        showSnackbar({
          message: response?.data?.msg,
          type: "info",
        })
      );
      return;
    }

    if (response?.status === 200) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: response?.data?.msg,
          type: "success",
        })
      );
      return response?.data; // Return data
    }
  } catch (error) {
    dispatch(
      showSnackbar({
        message: error?.response?.data?.msg,
        type: "error",
      })
    );
    console.error("API Error:", error);
    dispatch(setLoading(false));
    throw error; // Ensures error handling in components
  } finally {
    dispatch(setLoading(false));
  }
});

export const updateProject = createAsyncThunk("updateProject/", async (request, { dispatch }) => {
  try {
    const response = await authApi.put(`/updateProject/${request.order_id}`, request);

    if (response?.data?.status === 422) {
      dispatch(
        showSnackbar({
          message: response?.data?.msg,
          type: "info",
        })
      );
      return;
    }

    if (response?.status === 200) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: response?.data?.msg,
          type: "success",
        })
      );
      return response?.data; // Return data
    }
  } catch (error) {
    dispatch(
      showSnackbar({
        message: error?.response?.data?.msg,
        type: "error",
      })
    );
    console.error("API Error:", error);
    dispatch(setLoading(false));
    throw error; // Ensures error handling in components
  } finally {
    dispatch(setLoading(false));
  }
});

export const saveProjectScoopLastSeen = createAsyncThunk(
  "saveProjectScoopLastSeen/",
  async (request, { dispatch }) => {
    try {
      await authApi.post(`/saveProjectScoopLastSeen`, request);
    } catch (error) {
      console.error("API Error:", error);
      throw error; // Ensures error handling in components
    }
  }
);
export const itemsjobStatusGet = createAsyncThunk(
  "itemsjobStatusGet/",
  async ({ scoopId, id }, { dispatch }) => {
    try {
      const response = await authApi.get(`/itemsjobStatusGet/${scoopId}/${id}`);
      if (response?.status === 200) {
        return response?.data; // Return data
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error; // Ensures error handling in components
    }
  }
);
export const getFullScoopDetailList = createAsyncThunk(
  "scoopDetailGetByOrderId/",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.get(`/scoopDetailGetByOrderId/${request}`);

      if (response?.data?.status === 200) {
        dispatch(setFullScoopDetailList(response?.data?.data));
        dispatch(setLoading(false));
        return response; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const checkItemPonumberExist = createAsyncThunk(
  "checkItemPonumberExist/",
  async (request, { dispatch }) => {
    const {id, po_number} = request
    try {
      const encodedPoNumber = encodeURIComponent(po_number ?? "");
      const response = await authApi.get(
        `/checkItemPonumberExist/${id}/${encodedPoNumber}`
      );

      if (response?.status === 200) {
        return response; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const addNumberOfScoops = createAsyncThunk(
  "AddNumberOfItems/",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.post(`/AddNumberOfItems`, request);

      if (response?.status === 200) {
        dispatch(
          showSnackbar({
            message:
              response?.msg ||
              `${request?.no_of_items} scoop${
                request?.no_of_items > 1 ? "s" : ""
              } added successfully!`,
            type: "success",
          })
        );
        return response; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const scoopClientDropdown = createAsyncThunk(
  "checkContactClientId/",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.get(`/checkContactClientId/${request}`);

      if (response?.status === 200) {
        dispatch(setScoopClientDropdown(response?.data));
        return response; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const addScoopLink = createAsyncThunk("addScoopLinkUrl/", async (request, { dispatch }) => {
  try {
    const response = await authApi.post(`/addScoopLinkUrl`, request);

    if (response?.data?.status === 200) {
      dispatch(
        showSnackbar({
          message: response?.data?.msg,
          type: "success",
        })
      );
      return response; // Return data for component use
    }
  } catch (error) {
    console.error("API Error:", error);
    dispatch(setLoading(false));
    dispatch(
      showSnackbar({
        message: error?.response?.data?.msg,
        type: "error",
      })
    );
    throw error; // Ensures error handling in components
  } finally {
    dispatch(setLoading(false));
  }
});
export const poStatus = createAsyncThunk("ItemUpdate/", async (request, { dispatch }) => {
  try {
    const response = await authApi.put(`/ItemUpdate/${request?.Id}`, request?.request);

    if (response?.data?.status === 200) {
      dispatch(
        showSnackbar({
          message: response?.data?.msg,
          type: "success",
        })
      );
      return response; // Return data for component use
    }
  } catch (error) {
    console.error("API Error:", error);
    dispatch(setLoading(false));
    dispatch(
      showSnackbar({
        message: error?.response?.data?.msg,
        type: "error",
      })
    );
    throw error; // Ensures error handling in components
  } finally {
    dispatch(setLoading(false));
  }
});

export const updateProjectScoopClientPo = createAsyncThunk(
  "updateProjectScoopClientPo/",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.put(
        `/updateProjectScoopClientPo/${request?.itemId}`,
        { client_po_request: request?.client_po_request }
      );

      if (response?.data?.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
        return response; // Return data for component use
      }

      dispatch(
        showSnackbar({
          message: response?.data?.msg || "Not Updated",
          type: "error",
        })
      );
      throw new Error(response?.data?.msg || "Not Updated");
    } catch (error) {
      console.error("API Error:", error);
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg || error?.message,
          type: "error",
        })
      );
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const scoopTableList = createAsyncThunk(
  "scoopsummaryGet/",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.get(`/scoopsummaryGet/${request}`);

      if (response?.status === 200) {
        dispatch(setScoopTable(response?.data));
        dispatch(setLoading(false));
        return response; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const deleteScoopInTable = createAsyncThunk("itemDelete/", async (request, { dispatch }) => {
  const { order_id, item_id, item_number } = request;
  dispatch(setLoading(true));
  try {
    const response = await authApi.get(`/itemDelete/${item_id + "-" + item_number}/${order_id}`);

    if (response?.status === 200) {
      dispatch(
        showSnackbar({
          message: response?.msg,
          type: "success",
        })
      );
      return response; // Return data for component use
    }
  } catch (error) {
    console.error("API Error:", error);
    dispatch(
      showSnackbar({
        message: error?.response?.data?.msg,
        type: "error",
      })
    );
    throw error; // Ensures error handling in components
  } finally {
    dispatch(setLoading(false));
  }
});
export const saveScoop = createAsyncThunk("itemDelete/", async (request, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await authApi.put(
      `/ItemUpdate/${request?.order_id || request[0]?.order_id}`,
      request
    );

    if (response?.status === 200) {
      dispatch(
        showSnackbar({
          message: response?.data?.msg,
          type: "success",
        })
      );
      return response; // Return data for component use
    }
  } catch (error) {
    console.error("API Error:", error);
    dispatch(setLoading(false));
    dispatch(
      showSnackbar({
        message: error?.response?.data?.msg,
        type: "error",
      })
    );
    throw error; // Ensures error handling in components
  } finally {
    dispatch(setLoading(false));
  }
});

export const getMasterJobChanin = createAsyncThunk("itemDelete/", async (request, { dispatch }) => {
  try {
    const response = await authApi.get(`/masterJobchainget/${request?.order_id}`);

    if (response?.status === 200) {
      dispatch(setJobChainData(response?.data));
      return response; // Return data for component use
    }
  } catch (error) {
    console.error("API Error:", error);
    dispatch(setLoading(false));
    throw error; // Ensures error handling in components
  } finally {
    dispatch(setLoading(false));
  }
});

export const getSingleScoop = createAsyncThunk("itemDelete/", async (request, { dispatch }) => {
  try {
    const response = await authApi.get(`/itemsGetSingleScoop/${request?.item_id}`);

    if (response?.status === 200) {
      dispatch(setScoopDetailsForDashboardOverview(response?.data));
      return response; // Return data for component use
    }
  } catch (error) {
    console.error("API Error:", error);
    dispatch(setLoading(false));
    throw error; // Ensures error handling in components
  } finally {
    dispatch(setLoading(false));
  }
});

export const saveScoreForJobs = createAsyncThunk(
  "savescoreforjobs/",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.put(
        `/jobPmqascoreUpdate/${request?.job_summmeryId}`,
        request.payload
      );

      if (response?.status === 200) {
        return response; // Return data for component use
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      )
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const getJobSummeryForDropdown = createAsyncThunk(
  "itemDelete/",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.get(`/Jobsummeryget`);

      if (response?.status === 200) {
        dispatch(setJobData(response?.data));
        return response; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);
// Client Priice List
export const getPriceListDetails = createAsyncThunk(
  "getPricelistdata/",
  async (request, { dispatch }) => {
    try {
      const response =
        await authApi.get(`/getPriceList?order_id=${request?.order_id}&item_id=${request.item_id}&price_list_id=${request.price_list_id}&source_lang=${request.source_lang}&target_lang=${request.target_lang}&client=${request.client}
`);

      if (response?.status === 200) {
        const data = response?.data?.data;
        const isEmpty = !data || (Array.isArray(data) && data.length === 0);

        if (isEmpty) {
          // No price list found for this language pair — clear any stale entry for
          // this item so that new rows correctly fall back to price = 0.
          dispatch(
            setPriceListDetails({
              item_id: parseInt(request.item_id, 10) || request.item_id,
              price_basis: null,
            })
          );
        } else {
          dispatch(setPriceListDetails(data));
        }

        return response; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error; // Ensures error handling in components
    } finally {
    }
  }
);

// Resource Price List
export const getResourcesPriceList = createAsyncThunk(
  "getResourcesPricelistdata/",
  async (request, { dispatch }) => {
    try {
      const response =
        await authApi.get(`/getResourcePriceList?jobSummaryId=${request?.jobSummaryId}&resource=${request?.resource}
`);

      if (response?.status === 200) {
        dispatch(setPriceListForResources(response?.data?.data));
        return response; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const getFilesCount = createAsyncThunk(
  "getPricelistdata/",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.get(`/getScoopFilestotal/${request?.order_id}
`);

      if (response?.status === 200) {
        dispatch(setFileTotal(response?.data?.data));
        return response; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const getFileCountForJobs = createAsyncThunk(
  "getPricelistdata/",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.get(
        `/getJobFilesTotalByOrderOrItemId/${request?.order_id}${
          request?.item_number ? "/" + request?.item_number : ""
        }`
      );

      if (response?.status === 200) {
        dispatch(setFileTotalForJobs(response?.data?.data));
        return response; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const sendPo = createAsyncThunk("sendPo/", async (request, { dispatch }) => {
  try {
    const response = await authApi.post(`/sendPurchaseOrderLinguist`, request);

    if (response?.status === 200 && response?.data?.status === 200) {
      dispatch(
        showSnackbar({
          message: response?.data?.msg,
          type: "success",
        })
      );
      return response; // Return data for component use
    }

    const errorMsg =
      response?.data?.msg || "Unable to send Purchase Order email. Please try again.";
    dispatch(
      showSnackbar({
        message: errorMsg,
        type: "error",
      })
    );
    return Promise.reject(new Error(errorMsg));
  } catch (error) {
    console.error("API Error:", error);
    dispatch(setLoading(false));
    dispatch(
      showSnackbar({
        message:
          error?.response?.data?.msg ||
          "Unable to send Purchase Order email. Please try again.",
        type: "error",
      })
    );
    throw error; // Ensures error handling in components
  } finally {
    dispatch(setLoading(false));
  }
});

export const getDownloadPdfLink = createAsyncThunk(
  "genratedownloadlink/",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.post(`/getPurchaseOrderFile`, request);

      if (response?.status === 200) {
        return response; // Return data for component use
      }
    } catch (error) {
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const getFilesCountForSingleScoop = createAsyncThunk(
  "getPricelistdata/",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.get(`/getFilestotal/${request?.item_id}
`);

      if (response?.status === 200) {
        dispatch(setFileTotal(response?.data?.data));
        return response; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error; // Ensures error handling in components
    } finally {
    }
  }
);

export const getJobSummeryForTables = createAsyncThunk(
  "getjobsfortables/",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.get(
        `/jobsummeryGet/${request.order_id}${request?.itemNumber ? `/${request.itemNumber}` : ""}`
      );

      if (response?.status === 200) {
        dispatch(setDataForJobTable(response?.data));
        return response; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error; // Ensures error handling in components
    } finally {
    }
  }
);

export const createJobThunk = createAsyncThunk("saveProject/", async (request, { dispatch }) => {
  try {
    const response = await authApi.post(`/createNewJob`, request);

    if (response?.data?.status === 422) {
      dispatch(
        showSnackbar({
          message: response?.data?.msg,
          type: "info",
        })
      );
      return;
    }

    if (response?.status === 200) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: response?.data?.msg,
          type: "success",
        })
      );
      return response?.data; // Return data
    }
  } catch (error) {
    dispatch(
      showSnackbar({
        message: error?.response?.data?.msg,
        type: "error",
      })
    );
    console.error("API Error:", error);
    dispatch(setLoading(false));
    throw error; // Ensures error handling in components
  } finally {
    dispatch(setLoading(false));
  }
});

export const deleteJobThunk = createAsyncThunk("deletejob/", async (request, { dispatch }) => {
  try {
    const response = await authApi.delete(`/jobitemDelete/${request?.job_id}`);

    if (response?.data?.status === 422) {
      dispatch(
        showSnackbar({
          message: response?.data?.msg,
          type: "info",
        })
      );
      return;
    }

    if (response?.status === 200) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: response?.data?.msg,
          type: "success",
        })
      );
      return response?.data; // Return data
    }
  } catch (error) {
    dispatch(
      showSnackbar({
        message: error?.response?.data?.msg,
        type: "error",
      })
    );
    console.error("API Error:", error);
    dispatch(setLoading(false));
    throw error; // Ensures error handling in components
  } finally {
    dispatch(setLoading(false));
  }
});

export const getJobHistory = createAsyncThunk("getJobHistory/", async (request, { dispatch }) => {
  try {
    const response = await authApi.get(`/getJobRequestHistory/${request.job_id}`);
    if (response?.status === 200) {
      return response; // Return data for component use
    }
  } catch (error) {
    console.error("API Error:", error);
    throw error; // Ensures error handling in components
  } finally {
  }
});

export const pasteJobThunk = createAsyncThunk("deletejob/", async (request, { dispatch }) => {
  try {
    const response = await authApi.post(`/copyPasteJobToScoop`, request);

    if (response?.data?.status === 422) {
      dispatch(
        showSnackbar({
          message: response?.data?.msg,
          type: "info",
        })
      );
      return;
    }

    if (response?.status === 200) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: response?.data?.msg,
          type: "success",
        })
      );
      return response?.data; // Return data
    }
  } catch (error) {
    dispatch(
      showSnackbar({
        message: error?.response?.data?.msg,
        type: "error",
      })
    );
    console.error("API Error:", error);
    dispatch(setLoading(false));
    throw error; // Ensures error handling in components
  } finally {
    dispatch(setLoading(false));
  }
});

export const jobSummeryDetailsForAdmin = createAsyncThunk(
  "jobDetailsGet/list",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.get(`/jobSummeryDetailsGet/${request}`);
      if (response?.data?.status === 200) {
        dispatch(setJobDetails(response?.data));
        return response?.data;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const sendRequestInJob = createAsyncThunk("deletejob/", async (request, { dispatch }) => {
  try {
    const response = await authApi.post(`/jobSendRequest`, request?.request);

    if (response?.data?.status === 422) {
      dispatch(
        showSnackbar({
          message: response?.data?.msg,
          type: "info",
        })
      );
      return;
    }

    if (response?.status === 200) {
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: response?.data?.msg,
          type: "success",
        })
      );
      return response?.data; // Return data
    }
  } catch (error) {
    dispatch(
      showSnackbar({
        message: error?.response?.data?.msg,
        type: "error",
      })
    );
    console.error("API Error:", error);
    dispatch(setLoading(false));
    throw error; // Ensures error handling in components
  } finally {
    dispatch(setLoading(false));
  }
});
export const getFileFolders = createAsyncThunk("getFileFolders/", async (request, { dispatch }) => {
  dispatch(setLoading(true));
  try {
    const response = await authApi.get(`filefolderGet/${request}/null/null`);

    if (response?.status === 200) {
      dispatch(setLoading(false));
      dispatch(setFileFolders(response?.data));
      dispatch(
        showSnackbar({
          message: response?.data?.msg,
          type: "success",
        })
      );
      return response?.data; // Return data
    }
  } catch (error) {
    dispatch(
      showSnackbar({
        message: error?.response?.data?.msg,
        type: "error",
      })
    );
    console.error("API Error:", error);
    dispatch(setLoading(false));
    throw error; // Ensures error handling in components
  } finally {
    dispatch(setLoading(false));
  }
});

export const filefolderGetFreelanceJobs = createAsyncThunk(
  "filefolderGetFreelanceJobs/",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.get(`filefolderGetFreelanceJobs/${request}`);

      if (response?.status === 200) {
        dispatch(setLoading(false));

        return response?.data; // Return data
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg || "Failed!",
          type: "error",
        })
      );
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const getScoopFileFolders = createAsyncThunk(
  "getScoopFileFolders/",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.get(`scoopFileFolderGet/${request}`);

      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(setFileFolders(response?.data));

        return response?.data; // Return data
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg || "Failed!",
          type: "error",
        })
      );
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const getFileMangerList = createAsyncThunk(
  "getFileMangerList/",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.get(`getFileMangerList?${request}`);

      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(setFileFolders(response?.data));

        return response?.data; // Return data
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg || "Failed!",
          type: "error",
        })
      );
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const downloadFile = createAsyncThunk("downloadFile/", async (request, { dispatch }) => {
  try {
    const response = await authApi.get(`downloadFile/${request.fmanager_id}`, {
      responseType: "blob",
      headers: {
        Accept: "application/octet-stream", // or 'application/pdf', etc. depending on your file
      },
    });

    if (response?.status === 200) {
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", request.original_filename); // Just a generic name
      document.body.appendChild(link);
      link.click();
      link.remove();
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: response?.data?.msg || "Success!",
          type: "success",
        })
      );
      return response?.data; // Return data
    }
  } catch (error) {
    dispatch(
      showSnackbar({
        message: error?.response?.data?.msg || "Failed!",
        type: "error",
      })
    );
    console.error("API Error:", error);
    dispatch(setLoading(false));
    throw error; // Ensures error handling in components
  } finally {
    dispatch(setLoading(false));
  }
});

/** Fast download: same as downloadFile but uses streaming endpoint (downloadFileFast). Same request/response contract. */
export const downloadFileFast = createAsyncThunk("downloadFileFast/", async (request, { dispatch }) => {
  try {
    const response = await authApi.get(`downloadFileFast/${request.fmanager_id}`, {
      responseType: "blob",
      headers: {
        Accept: "application/octet-stream",
      },
    });

    if (response?.status === 200) {
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", request.original_filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      dispatch(setLoading(false));
      dispatch(
        showSnackbar({
          message: response?.data?.msg || "Success!",
          type: "success",
        })
      );
      return response?.data;
    }
  } catch (error) {
    dispatch(
      showSnackbar({
        message: error?.response?.data?.msg || "Failed!",
        type: "error",
      })
    );
    console.error("API Error:", error);
    dispatch(setLoading(false));
    throw error;
  } finally {
    dispatch(setLoading(false));
  }
});

// file dowload for s3 signurl
export const downloadFile__ = createAsyncThunk(
  "downloadFile/",
  async (request, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setLoading(true));

      // 1️⃣ Call API to get pre-signed URL
      const response = await authApi.get(
        `downloadFile/${request.fmanager_id}`
      );

      if (response?.data?.status !== 200 || !response?.data?.download_url) {
        throw new Error("Invalid download link");
      }

      const downloadUrl = response.data.download_url;

      // 2️⃣ Trigger browser download (BEST way)
      window.location.href = downloadUrl;

      dispatch(
        showSnackbar({
          message: "Download started",
          type: "success",
        })
      );

      return true;
    } catch (error) {
      dispatch(
        showSnackbar({
          message:
            error?.response?.data?.msg || "Download failed",
          type: "error",
        })
      );
      return rejectWithValue(error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const fileDownloadStatusUpdate = createAsyncThunk(
  "fileDownloadStatusUpdate /",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.post(`fileDownloadStatusUpdate`, {
        fmanager_id: Number(request.fmanager_id),
        jobId: Number(request.jobId),
      });
      if (response?.status === 200) {
        return response?.data; // Return data
      }
    } catch (error) {
      throw error; // Ensures error handling in components
    }
  }
);

export const fileManagerUpdate = createAsyncThunk(
  "fileManagerUpdate/",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.put(`/fileManagerRename/${request.id}`, request.payload);

      if (response?.status === 200) {
        request.scoopId && dispatch(getScoopFileFolders(request.scoopId));
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
        return response?.data; // Return data
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    }
  }
);
export const deleteMutiFileFolder = createAsyncThunk(
  "filemanagerfolderDeleteMultiple/",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.post(`/filemanagerfolderDeleteMultiple`, request.payload);

      if (response?.status === 200) {
        request.scoopId && dispatch(getScoopFileFolders(request.scoopId));
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
        return response?.data; // Return data
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    }
  }
);
export const fileManagerPaste = createAsyncThunk(
  "fileManagerPaste/",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.post(`/fileManagerPaste`, request.payload);

      if (response?.status === 200) {
        request.scoopId && dispatch(getScoopFileFolders(request.scoopId));
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
        return response?.data; // Return data
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    }
  }
);
export const copyScoopFilesToScoop = createAsyncThunk(
  "copyScoopFilesToScoop",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.post("/copyScoopFilesToScoop", request);

      if (response?.status === 200) {
        request.sourceScoopId && dispatch(getScoopFileFolders(request.sourceScoopId));
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
        return response?.data;
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg || "Failed to copy files.",
          type: "error",
        })
      );
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error;
    }
  }
);
export const globalSearchProjectHeader = createAsyncThunk(
  "globalSearchProjectHeader/",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.post(`/globalSearchProjectHeader`, request);

      if (response?.status === 200) {
        // Empty searchKey returns recently visited scoops only — do not wipe live search results.
        if ((request?.searchKey || "").trim()) {
          dispatch(setGlobalSearch(response.data));
        }
        return response?.data;
      }
    } catch (error) {
      // Quiet for empty recent-visited fetch; keep snackbar for actual searches.
      if ((request?.searchKey || "").trim()) {
        dispatch(
          showSnackbar({
            message: error?.response?.data?.msg,
            type: "error",
          })
        );
      }
      console.error("API Error:", error);
      throw error; // Ensures error handling in components
    }
  }
);
export const Newfoldermake = createAsyncThunk("Newfoldermake", async (request, { dispatch }) => {
  try {
    const response = await authApi.get(`Newfoldermake/${request.parentId}/${request.title}/1`);

    if (response?.status === 200) {
      dispatch(setLoading(false));
      request.scoopId && dispatch(getScoopFileFolders(request.scoopId));
      dispatch(
        showSnackbar({
          message: response?.data?.msg,
          type: "success",
        })
      );
      return response?.data; // Return data
    }
  } catch (error) {
    dispatch(
      showSnackbar({
        message: error?.response?.data?.msg,
        type: "error",
      })
    );
    console.error("API Error:", error);
    dispatch(setLoading(false));
    throw error; // Ensures error handling in components
  } finally {
    dispatch(setLoading(false));
  }
});
export const getProjectDetails = createAsyncThunk(
  "getProjectDetails/",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.get(`/projectgetOne/${request.order_id}`);

      if (response?.status === 200) {
        dispatch(setProjectDetail(response?.data?.data));
        return response; // Return data for component use
      }
    } catch (error) {
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const actionsForJob = createAsyncThunk("deletejob/", async (request, { dispatch }) => {
  try {
    const response = await authApi.put(`/updateJobsInBulk/${request.userId}`, request.payloadData);

    if (response?.data?.status === 422) {
      dispatch(
        showSnackbar({
          message: response?.data?.msg,
          type: "info",
        })
      );
      return;
    }

    if (response?.status === 200) {
      dispatch(setLoading(false));
      const skipped = response?.data?.skipped || [];
      const statusBlocked = skipped.filter((job) =>
        typeof job?.reason === "string" &&
        (job.reason.includes("Invoiced") || job.reason.includes("Paid") || job.reason.includes("invoice"))
      );

      if (statusBlocked.length > 0 && (response?.data?.updated || []).length === 0) {
        dispatch(
          showSnackbar({
            message: statusBlocked[0]?.reason || "Cannot update status for Invoiced or Paid jobs.",
            type: "error",
          })
        );
      } else if (statusBlocked.length > 0) {
        dispatch(
          showSnackbar({
            message: `${(response?.data?.updated || []).length} job(s) updated. ${statusBlocked.length} job(s) skipped (Invoiced/Paid protection).`,
            type: "info",
          })
        );
      } else {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
      }
      return response?.data; // Return data
    }
  } catch (error) {
    dispatch(
      showSnackbar({
        message: error?.response?.data?.msg,
        type: "error",
      })
    );
    console.error("API Error:", error);
    dispatch(setLoading(false));
    throw error; // Ensures error handling in components
  } finally {
    dispatch(setLoading(false));
  }
});
export const discussionOrderCreate = createAsyncThunk(
  "discussionOrder/",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.post(`/discussionOrder`, request);

      if (response?.status === 200) {
        return response?.data; // Return data
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const discussionOrderEdit = createAsyncThunk(
  "discussionOrder/edit",
  async ({ id, payload }, { dispatch }) => {
    try {
      const response = await authApi.put(`/discussionOrder/${id}`, payload);

      if (response?.status === 200) {
        return response?.data; // Return data
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const discussionScoop = createAsyncThunk(
  "discussionChatList/",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.get(
        `/discussionChatList/${request?.id}?type=${request?.type}`
      );

      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(setDiscussionScoop(response?.data));
        return response?.data; // Return data
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const discussionScoopDetails = createAsyncThunk(
  "discussionScoopDetails/",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.get(`/discussionScoopDetails/${request}`);

      if (response?.status === 200) {
        dispatch(setdiscussionScoopDetails(response?.data));
        dispatch(setLoading(false));
        return response?.data; // Return data
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const discussionJobDetails = createAsyncThunk(
  "discussionJobDetails/",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.get(`/discussionJobDetails/${request}`);

      if (response?.status === 200) {
        dispatch(setdiscussionJobDetails(response?.data));
        dispatch(setLoading(false));
        return response?.data; // Return data
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const updateReadUnreadChat = createAsyncThunk(
  "updateReadUnreadChat",
  async (request, { dispatch, rejectWithValue }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.put(`/discussionCommentread/${request?.job_id}`, request);
      if (response?.status === 200) {
        return response?.status;
      } else {
        return rejectWithValue("Unexpected API response");
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const itemsScoopsDropdown = createAsyncThunk(
  "itemsScoopsDropdown/",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.get(`/itemsScoopsDropdown/${request}`);

      if (response?.status === 200) {
        dispatch(setitemsScoopsDropdown(response?.data));
        dispatch(setLoading(false));
        return response?.data; // Return data
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const selectJobDataByOrderIdDropdown = createAsyncThunk(
  "select2JobdataByOrderid/",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.get(`/select2JobdataByOrderid/${request}`);

      if (response?.status === 200) {
        dispatch(setselectJobDataByOrderId(response?.data));
        dispatch(setLoading(false));
        return response?.data; // Return data
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const getMailTemplateForJobs = createAsyncThunk(
  "itemsScoopsDropdown/",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.get(
        `/getEmailTemplate?templateId=13&userId=${request.userId}`
      );

      if (response?.status === 200) {
        return response?.data; // Return data
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);

//Get User Dashboard Tabs Order
export const getUserDashboardTabs = createAsyncThunk(
  "getUserDashboardTabs",
  async ({ id, isglobal }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      // Build dynamic URL
      let url = `getUserTabs/${id}`;
      if (isglobal) {
        url += `?is_global=1`;
      }

      const response = await authApi.get(url);
      if (response?.data?.status === 200) {
        dispatch(setUserDashboardTabs(response.data?.data));
        dispatch(setLoading(false));
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);

//Update User Dashboard Tabs Order
export const updateUserDashboardTabsOrder = createAsyncThunk(
  "updateUserDashboardTabsOrder",
  async ({ payload, id }) => {
    try {
      await authApi.put(`updateUserTabsortorder/${id}`, payload);
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  }
);

export const createCustomTab = createAsyncThunk(
  "createCustomTab",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));

    try {
      const response = await authApi.post(`/createCustomTab`, request);
      return response?.data; // Return data for component use
    } catch (error) {
      console.error("API Error:", error);
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const deleteCustomTab = createAsyncThunk(
  "deleteCustomTab/",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.delete(`/deleteCustomTab/${request?.id}`);
      if (response?.data?.status === 422) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "info",
          })
        );
        return;
      }
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
        return response?.data; // Return data
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const updateCustomTab = createAsyncThunk(
  "updateCustomTab",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.put(`/updateCustomTab/${request?.tab_id}`, request);
      return response?.data; // Return data for component use
    } catch (error) {
      console.error("API Error:", error);
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const getGeneralMasterDropDownList = createAsyncThunk(
  "dropdown/getGeneralMasterDropDownList",
  async (params = {}, { dispatch, rejectWithValue }) => {
    // dispatch(setLoading(true));
    try {
      const queryString = new URLSearchParams(params).toString();
      const response = await authApi.get(`/masterDropdownList?${queryString}`);

      if (response?.status === 200) {
        dispatch(setGeneralMasterDropDownList(response.data?.data));
        return response.data?.data;
      } else {
        return rejectWithValue("Unexpected API response");
      }
    } catch (error) {
      console.error("Master Dropdown API Error:", error);
    } finally {
      // dispatch(setLoading(false));
    }
  }
);

export const downloadTableDataInExcel = createAsyncThunk(
  "downloadTableDataInExcel/",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));

      const response = await authApi.post(`/generateExcelfileReport`, request);

      if (response?.status === 200 && response?.data?.fileBase64) {
        const { fileBase64, fileName } = response.data;

        // Convert Base64 string to Blob
        const base64Parts = fileBase64.split(",");
        const mime = base64Parts[0].match(/:(.*?);/)[1]; // e.g., application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
        const byteCharacters = atob(base64Parts[1]);
        const byteNumbers = new Array(byteCharacters.length)
          .fill(0)
          .map((_, i) => byteCharacters.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mime });

        // Create a download link
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = fileName || "report.xlsx";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);

        dispatch(
          showSnackbar({
            message: response?.data?.msg || "File downloaded successfully!",
            type: "success",
          })
        );

        return response.data;
      } else {
        throw new Error(response?.data?.msg || "File content not found");
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg || "Download failed!",
          type: "error",
        })
      );
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const updateDashboardCommentStatus = createAsyncThunk(
  "updateDashboardCommentStatus",
  async (request, { dispatch, rejectWithValue }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.put(`/discussionCommentread/${request?.scoop_id}`, request);
      if (response?.status === 200) {
        return response?.status;
      } else {
        return rejectWithValue("Unexpected API response");
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error; // Ensures error handling in components
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const startEditing = createAsyncThunk(
  "startEditing",
  async (request, { dispatch }) => {
    try {
      const body = {};
      if (request?.status) {
        body.status = request.status;
      }
      if (request?.lastActivityAt) {
        body.lastActivityAt = request.lastActivityAt;
      }
      if (typeof request?.dirty === "boolean") {
        body.dirty = request.dirty;
      }

      const response = await authApi.post(
        `/scoop/${request?.id}/editing`,
        Object.keys(body).length > 0 ? body : undefined
      );

      if (response?.status === 200) {
        return response?.data;
      }
    } catch (error) {
      console.warn("startEditing (non-critical):", error?.response?.data?.msg ?? error?.message);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const stopEditing = createAsyncThunk(
  "stopEditing",
  async (request, { dispatch }) => {
    try {
      // Stop presence (server derives user from auth token)
      const response = await authApi.delete(`/scoop/${request?.id}/editing`);

      if (response?.status === 200) {
        return response?.data; // Return data
      }
    } catch (error) {
      console.warn("stopEditing (non-critical):", error?.response?.data?.msg ?? error?.message);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const editingUsers = createAsyncThunk(
  "editingUsers",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.get(`/scoop/${request}/editingUsers`);

      if (response?.status === 200) {
        const users = response?.data?.data ?? [];
        dispatch(setEditingUsers(users));
        return users;
      }
    } catch (error) {
      console.warn("editingUsers (non-critical):", error?.response?.data?.msg ?? error?.message);
      dispatch(setEditingUsers([]));
      return [];
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const fetchDueTodayCongratulationStatus = createAsyncThunk(
  "dashboard/dueTodayCongratulationStatus",
  async (_, { rejectWithValue }) => {
    try {
      const response = await authApi.get("/dashboard/due-today-congratulation-status");
      if (response?.status === 200) {
        const body = response?.data ?? {};
        return body?.data ?? body;
      }
      return rejectWithValue("Unexpected response status");
    } catch (error) {
      return rejectWithValue(error?.message ?? "Failed to fetch due today status");
    }
  }
);

export const getAlertNotification = createAsyncThunk(
  "getAlertNotification",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.get(`/getAlertsNotification/${request?.userid}`);

      if (response?.status === 200) {
        const alerts = response.data?.data ?? [];
        const unseenCount = response.data?.meta?.unseen_count ?? 0;
        dispatch(setAlertNotification({ alerts, unseenCount }));
        return { alerts, unseenCount };
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.error("API Error:", error);
      dispatch(setLoading(false));
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const markAlertsSeen = createAsyncThunk(
  "markAlertsSeen",
  async (_, { dispatch, getState }) => {
    try {
      const response = await authApi.put("/markAlertsSeen");
      if (response?.status === 200) {
        dispatch(markAllAlertsSeenInState());
        const userId = getState()?.root?.authUser?.user?.iUserId;
        if (userId) {
          await dispatch(getAlertNotification({ userid: userId }));
        }
        return response.data;
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg || "Failed to mark alerts as seen",
          type: "error",
        })
      );
      throw error;
    }
  }
);

export const markAlertSeen = createAsyncThunk(
  "markAlertSeen",
  async (alertId, { dispatch, getState }) => {
    try {
      const response = await authApi.put(`/markAlertSeen/${alertId}`);
      if (response?.status === 200) {
        dispatch(markAlertSeenInState(alertId));
        const userId = getState()?.root?.authUser?.user?.iUserId;
        if (userId) {
          await dispatch(getAlertNotification({ userid: userId }));
        }
        return response.data;
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg || "Failed to mark alert as seen",
          type: "error",
        })
      );
      throw error;
    }
  }
);

export const dismissAlertNotification = createAsyncThunk(
  "dismissAlertNotification",
  async (alertId, { dispatch, getState }) => {
    try {
      const response = await authApi.put(`/dismissAlertNotification/${alertId}`);

      if (response?.status === 200) {
        const userId = getState()?.root?.authUser?.user?.iUserId;
        if (userId) {
          await dispatch(getAlertNotification({ userid: userId }));
        }
        return response.data;
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg || "Failed to dismiss alert",
          type: "error",
        })
      );
      throw error;
    }
  }
);

export const checkLinguistWorkload = createAsyncThunk(
  "checkLinguistWorkload",
  async ({ resourceId }, { rejectWithValue }) => {
    try {
      const id = Number(resourceId);
      if (!id) return rejectWithValue("Invalid resource id");

      const response = await authApi.get(`/linguists/${id}/workload`);
      if (response?.status === 200) {
        return response?.data?.data ?? response?.data;
      }
      return rejectWithValue("Unexpected response status");
    } catch (error) {
      return rejectWithValue(error?.response?.data?.msg ?? error?.message ?? "Failed to check workload");
    }
  }
);
